import Vue from "vue"

const state = {

}

const mutations = {

}

const actions = {
    async fetchOneAuction({ dispatch }, idAuction) {
        const { data, status } = await Vue.axios.get(`/auctions/${idAuction}`);
        if (status != 200) {
            await dispatch("generateSnackBarMessage", { message: 'Ocurrió un error al obtener los rubros', type: 'error' })
        };
        return { data, status };
    },

    async fetchAuctionsByCategory({ dispatch }, idAuction) {
        const { data, status } = await Vue.axios.get(`/auctions/category/${idAuction}`);
        if (status != 200) {
            await dispatch("generateSnackBarMessage", { message: 'Ocurrió un error al obtener los rubros', type: 'error' })
        };
        return { data, status };
    },
    async createAuction({ dispatch }, auction) {
        const formData = new FormData();
        formData.append('file_cover_page', auction.file_cover_page);
        formData.append('title_auctions', auction.title_auctions);
        formData.append('register_url', auction.register_url);
        formData.append('end_date', auction.end_date);
        formData.append('id_category', auction.id_category);
        const { data, status } = await Vue.axios.post("/auctions", formData);
        if (status != 200 && status != 201) {
            await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error guardando los datos del rubro', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
        }
        return { data, status };
    },
    async updateAuction({ dispatch }, auction) {
        const formData = new FormData();
        formData.append('title_auctions', auction.title_auctions);
        formData.append('register_url', auction.register_url);
        formData.append('end_date', auction.end_date);
        formData.append('id_category', auction.id_category);
        if (auction.file_cover_page) {
            formData.append('file_cover_page', auction.file_cover_page)
        }
        const { data, status } = await Vue.axios.post(`/auctions/${auction.id}`, formData);
        if (status != 200 && status != 201 && status != 204) {
            await dispatch("createResponseMessage", { message: data.message || 'Ocurrió un error actualizando los datos del rubro', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Se guardó correctamente', type: 'success' })
        }
        return { data, status };
    },
    async removeAuction({ dispatch }, auction) {
        const { data, status } = await Vue.axios.delete(`/auctions/${auction.id}`);
        if (status != 200 && status != 204) {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Ocurrió un error eliminando al rubro del sistema', type: 'error' })
        } else {
            await dispatch("generateSnackBarMessage", { message: data.message || 'Rubro eliminado correctamente', type: 'success' })
        }
        return { data, status };
    }
}

export default { state, mutations, actions }